
import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';

const PlanInternationalRateListField = ({ errors, touched, values, setFieldValue, darkMode, enumArray }) => {
    const [isHovered, setIsHovered] = useState(false);
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = 'ChakraSelect';

    // Convert enumArray to react-select format, filter only active rate lists
    const options = enumArray
        .filter(opt => opt.isActive === true)
        .map(opt => ({ value: opt.id, label: opt.name }));
    const selectedOption = options.find(op => op.value === values?.internationalRateListID) || null;

    return (
        <FormControl
            isInvalid={!!errors.internationalRateListID && touched.internationalRateListID}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} align="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        International Rate List
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the international rate list for this plan.
                    </Text>
                </Box>
                <Box flex="1" sx={{ paddingTop: '15px' }}>
                    <Field name="internationalRateListID">
                        {({ form }) => (
                            <ChakraSelect
                                minWidth="410px"
                                width="100%"
                                data-walkthroughid={walkthroughIds.plans.ufInternationalRateSelect}
                                options={options}
                                placeholder="- Select International Rate List -"
                                menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                                getOptionLabel={i => i.label}
                                getOptionValue={i => i.value}
                                chakraStyles={dropDownFormStyle(darkMode)}
                                isLoading={form.isSubmitting}
                                isDisabled={form.isSubmitting}
                                value={selectedOption}
                                isClearable
                                onChange={option => {
                                    form.setFieldValue('internationalRateListID', option ? option.value : '');
                                    form.validateField('internationalRateListID');
                                }}
                                onBlur={() => {
                                    form.setFieldTouched('internationalRateListID', true);
                                }}
                            />
                        )}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the international rate list."
                        ariaLabel="plan-international-rate-list-tip"
                        left="25px"
                        top="5px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanInternationalRateListField;
